import { getLookupList } from "../utils/apiUtils"
import { ENTITY_NAME_BRAND_VOICE } from "./dbConstants";

export const getListOptions = async(input) => {
  console.log("BrandVoiceDAO.getListOptions - input:", input);
  return getLookupList(ENTITY_NAME_BRAND_VOICE)
}